import $ from 'jquery';
import Alert from './util/alert';
import { getParams, createParams } from './util/urlParam';
import { strToList } from './util/strToList';
import { conditions, nameIndexs } from './variables';
import LabelComponent from './components/LabelComponent';
import CompanyCard from './components/CompanyCard';
import PrCompanyCard from './components/PrCompanyCard';
import {
  User,
  Company,
  GiftShow,
  ScContent,
  Fair,
  Floor,
  Category,
  Province,
  SearchCondition,
} from './model/index';
import {
  getUserJqXHR,
  getShowJqXHR,
  getScJqXHR,
  getFloorJqXHR,
  getFairJqXHR,
  getProvinceJqXHR,
  searchJqXHR,
  prSearchJqXHR,
  postConsiderJqXHR,
  deleteConsiderJqXHR,
  getTagJqXHR,
  getCategoryJqXHR,
} from './api';
import translate, { Lang } from './util/translate';
import { login, logout } from './util/auth';

$(() => {
  $('#loading').show(); // ロードを開始
  translate(); // 翻訳

  // 言語
  let tmplang = localStorage.getItem('lang') ?? 'ja';
  if(tmplang == 'cn'){
    tmplang = 'ja';
  }
  const lang = (tmplang) as keyof Lang;

  $('.login').on('click', login);
  $('.logout').on('click', logout);

  // URLパラメータ 取得
  const params = getParams(conditions);
  const pPage = parseInt(params.page ?? '1');
  const pShow = params.show ?? '';
  const pFloor = params.floor ?? '';
  const pFair = params.fair ?? '';
  const pFreeword = params.freeword ? decodeURIComponent(params.freeword) : '';
  const pCategory = strToList(params.category);
  const pHashtag = strToList(params.hashtag).map((tag) => {
    return decodeURIComponent(tag);
  });
  const pNameIndex = params.abc ? decodeURIComponent(params.abc) : '';
  const pPrefecture = parseInt(params.prefecture ?? '0');
  const pContent = params.content ?? '';
  const pRegisteredName = params.registered_name
    ? decodeURIComponent(params.registered_name)
    : '';
  const pOrder = params.order ?? '1';

  // 検索条件
  const cond: SearchCondition = {
    show_code: pShow,
    floor_code: pFloor,
    fair_code: pFair,
    freeword: pFreeword,
    category_code: pCategory[0] === '' || pCategory[0] === '0' ? [] : pCategory,
    tag: pHashtag,
    name_index: pNameIndex,
    province_code: String(pPrefecture) === '0' ? '' : String(pPrefecture),
    sc_key: pContent,
    registered_name: pRegisteredName,
    order: pOrder,
  };

  // ユーザー情報 取得
  const userJqXHR = getUserJqXHR();
  userJqXHR
    .done((user: User) => {
      $('#profile-username').text(`${user.name} 様`);
      $('.profile-authorized a').show();
      $('#profile-unauthorized a').hide();
      $('#profile-authorized-smp a').show();
      $('#profile-unauthorized-smp a').hide();
      $('#header-menu-authorized').show();
      $('#header-menu-unauthorized').hide();
    })
    .catch(() => {
      $('.profile-authorized a').hide();
      $('#profile-unauthorized a').show();
      $('#profile-authorized-smp a').hide();
      $('#profile-unauthorized-smp a').show();
      $('#header-menu-authorized').hide();
      $('#header-menu-unauthorized').show();
    })
    .always(() => {
      const seJqXHR = searchJqXHR(pPage, cond);
      const prJqXHR = prSearchJqXHR();
      const showJqXHR = getShowJqXHR();
      const scJqXHR = getScJqXHR();
      const floorJqXHR = getFloorJqXHR(pShow);
      const fairJqXHR = getFairJqXHR(pShow);
      const tagJqXHR = getTagJqXHR();
      const provinceJqXHR = getProvinceJqXHR();
      const categoryJqXHR = getCategoryJqXHR();

      $.when(
        seJqXHR,
        prJqXHR,
        showJqXHR,
        scJqXHR,
        floorJqXHR,
        fairJqXHR,
        tagJqXHR,
        provinceJqXHR,
        categoryJqXHR
      )
        .done(
          (
            jqSearch,
            jqPr,
            jqShow,
            jqSc,
            jqFloors,
            jqFair,
            jqTag,
            jqProvince,
            jqCategory
          ) => {
            // マスターデータ
            const total: number = jqSearch[0].total;
            const companies: Company[] = jqSearch[0].data;
            const prcompanies: Company[] = jqPr[0].data;
            const shows: GiftShow[] = jqShow[0];
            const contents: ScContent[] = jqSc[0].data;
            const floors: Floor[] = jqFloors[0];
            const fairs: Fair[] = jqFair[0];
            const categories: Category[] = jqCategory[0];

            const hashtags: string[] = jqTag[0];
            const prefectures: Province[] = jqProvince[0];

            // 検索結果 表示
            let companyList = '';
            if (companies && companies.length > 0) {
              companies.forEach((item) => {
                companyList += CompanyCard(item);
              });
              $('#search-result-campany').html(companyList);
            }
            $('#search-result-campany-number').html(`${total}`);

            // 検索結果 表示
            // let prcompanyList = '';
            // if (prcompanies && prcompanies.length > 0) {
            //   prcompanies.forEach((item) => {
            //     prcompanyList += PrCompanyCard(item);
            //   });
            //   $('#search-result-prcampany').html(prcompanyList);
            // }

            // 検索条件の情報を表示
            let searchCondition = '';
            let showCondition = '';
            let fairCondition = '';
            let prefectureCondition = '';
            let categoryConditionList = '';
            let freewordConditionList = '';
            let nameIndexConditionList = '';

            const addConditionHtml = (name: string, condition: string) => {
              if (condition === '') return;
              // 既に条件がある場合は先頭に "、" を追加
              if (searchCondition !== '') {
                searchCondition += '<span>、</span>';
              }
              searchCondition += `<div class="condition">${name}：<ul>${condition}</ul></div>`;
            };

            // 出展見本市
            if (cond.show_code !== '') {
              const resultShow = shows.find(
                (item) => item.show_code === cond.show_code
              );
              if (!resultShow) return;

              const showName = resultShow.show_name;
              showCondition = `<li>${showName}</li>`;
              const name = `<p class='trn' data-trn-key='productShow'>出展見本市：</p>`;
              addConditionHtml(name, showCondition);
            }

            // 出展社の所在地
            if (cond.province_code !== '') {
              const resultPrefecture = prefectures.find(
                (item) => String(item.province_code) === cond.province_code
              );
              if (!resultPrefecture) return;

              const prefectureName = resultPrefecture.province_name;
              prefectureCondition = `<li>${prefectureName}</li>`;

              const name = `<p class='trn' data-trn-key='productPrefecture'>出展の所在地：</p>`;
              addConditionHtml(name, prefectureCondition);
            }

            // 出展フェア
            if (cond.fair_code !== '') {
              const resultFair = fairs.find(
                (item) => item.fair_code === cond.fair_code
              );
              if (!resultFair) return;

              const fairName = resultFair.fair_name;
              fairCondition = `<li>${fairName}</li>`;

              const name = `<p class='trn' data-trn-key='productFair'>出展フェア：</p>`;
              addConditionHtml(name, fairCondition);
            }

            // カテゴリー 取り扱い品目
            if (cond.category_code && cond.category_code.length > 0) {
              cond.category_code.forEach((code) => {
                if (
                  cond.category_code.length === 1 &&
                  (code === '0' || !code)
                ) {
                  // カテゴリーの検索条件がない場合
                  categoryConditionList = '';
                } else {
                  // cond.category_codeと一致するカテゴリーを取得
                  const resultItem = categories.filter(
                    (item) => String(item.category_code) === code
                  );

                  // resultItemが存在した場合
                  if (resultItem.length > 0 && resultItem[0].category_name) {
                    const categoryName = resultItem[0].category_name;
                    categoryConditionList += `<li>${categoryName}</li>`;
                  }
                }
              });

              const name = `<p class='trn' data-trn-key='productCategory'>カテゴリー</p>`;
              addConditionHtml(name, categoryConditionList);
            }

            // フリーワード
            if (cond.freeword !== '') {
              freewordConditionList = cond.freeword;

              const name = `<p class='trn' data-trn-key='productFreeword'>フリーワード</p>`;
              addConditionHtml(name, freewordConditionList);
            }

            // 頭文字
            if (cond.name_index !== '') {
              nameIndexConditionList = cond.name_index;

              const name = `<p class='trn' data-trn-key='productNameIndex'>出展社の頭文字</p>`;
              addConditionHtml(name, nameIndexConditionList);
            }

            // 検索条件の表示
            $('#search-condition').html(searchCondition);

            // 検討リストへの追加 削除機能
            $(document).on('click', '.campany-content', function () {
              // アイコン 要素
              const considerAdd = $(this).find('.company-star');
              const considerDelete = $(this).find('.company-star-active');
              // 企業ID
              const shop_id: string = $(this).data('shop_id');

              // お気に入り登録しているかどうか
              const favorite: boolean =
                $(this)[0].getAttribute('data-favorite') === 'true' && true;

              // お気に入りの登録 or 解除
              if (!favorite) {
                const favoJqXHR = postConsiderJqXHR(shop_id);
                considerAdd.hide();
                considerDelete.show();
                $(this).addClass('company-consider-active');
                favoJqXHR
                  .done(() => {
                    $(this)[0].setAttribute('data-favorite', 'true');
                  })
                  .fail(() => {
                    considerAdd.show();
                    considerDelete.hide();
                    Alert({
                      icon: 'error',
                      titleKey: 'errNeedLogin',
                      trnKey: 'errRegisterFavorite',
                      confirmButtonKey: 'login',
                      onClick: () => login(),
                    });
                  });
              } else {
                const favoJqXHR = deleteConsiderJqXHR(shop_id);
                considerDelete.hide();
                considerAdd.show();
                $(this).removeClass('company-consider-active');
                favoJqXHR
                  .done(() => {
                    $(this)[0].setAttribute('data-favorite', 'false');
                  })
                  .fail(() => {
                    considerAdd.hide();
                    considerDelete.show();
                    Alert({
                      icon: 'error',
                      trnKey: 'errRemoveFavorite',
                      confirmButtonKey: 'login',
                      onClick: () => login(),
                    });
                  });
              }
            });

            // ページネーション
            const nPage = Math.ceil(total / 20); // ページ数
            if (nPage > 0) {
              let pagination: string = '';
              const _params: { [key: string]: string } = {};
              if (params.show) _params.show = params.show;
              if (params.floor) _params.floor = params.floor;
              if (params.fair) _params.fair = params.fair;
              if (params.freeword) _params.freeword = params.freeword;
              if (params.category) _params.category = params.category;
              if (params.hashtag) _params.hashtag = params.hashtag;
              if (params.abc) _params.abc = params.abc;
              if (params.prefecture) _params.prefecture = params.prefecture;
              if (params.content) _params.content = params.content;
              if (params.order) _params.order = params.order;

              const _preParams = _params;
              _preParams.page = `1`;
              const _preUrl = createParams(_preParams);
              pagination += `
                <li class="page-item ${pPage === 1 ? `disabled` : ''}">
                  <a class="page-link" aria-label="Previous" href="./${_preUrl}">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
              `;
              const count = 7; // ページネーション個数
              const _max =
                Math.ceil(count / 2) - 1 + pPage > count
                  ? Math.ceil(count / 2) - 1 + pPage
                  : count;
              const _min = pPage - count / 2 > 1 ? pPage - count / 2 : 1;
              for (let i = 1; i <= nPage; i++) {
                if (i >= _min && i <= _max) {
                  const _subParams = _params;
                  _subParams.page = `${i}`;
                  const _url = createParams(_subParams);
                  pagination += `<li class="page-item ${
                    pPage === i ? `active` : ''
                  }"><a class='page-link' href='./${_url}'>${i}</a></li>`;
                }
              }
              const _nextParams = _params;
              _nextParams.page = `${nPage}`;
              const _nextUrl = createParams(_nextParams);
              pagination += `
                <li class="page-item ${pPage === nPage ? `disabled` : ''}">
                  <a class="page-link" aria-label="Next" href="./${_nextUrl}">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              `;
              $('#search-result-pagination').html(pagination);
            }

            // 検索条件
            // ショー
            const resultShow = shows.find((item) => item.show_code === pShow)
              ?.show_name;
            if (resultShow !== undefined) {
              $('#search-condition-show').show();
              $('#search-condition-show .card-text').text(resultShow);
            } else {
              $('#search-condition-show').hide();
            }
            // 特集
            const resultContent = contents.find(
              (item) => item.sc_key === pContent
            )?.content_name;
            if (resultContent !== undefined) {
              $('#search-condition-content').show();
              $('#search-condition-content .card-text').text(resultContent);
            } else {
              $('#search-condition-content').hide();
            }
            // フロア
            const resultFloor = floors.find(
              (item) => item.floor_code === pFloor
            )?.floor_name;
            if (resultFloor !== undefined) {
              $('#search-condition-floor').show();
              $('#search-condition-floor .card-text').text(resultFloor);
            } else {
              $('#search-condition-floor').hide();
            }
            // フェア
            const resultFair = fairs.find((item) => item.fair_code === pFair)
              ?.fair_name;
            if (resultFair !== undefined) {
              $('#search-condition-fair').show();
              $('#search-condition-fair .card-text').text(resultFair);
            } else {
              $('#search-condition-fair').hide();
            }
            // フリーワード
            if (pFreeword !== '' && pFreeword !== null) {
              $('#search-condition-freeword').show();
              $('#search-condition-freeword .card-text').text(pFreeword);
            } else {
              $('#search-condition-freeword').hide();
            }
            // 商品カテゴリ
            if (pCategory.length > 0) {
              let resultCategory: string = '';
              pCategory.forEach((item) => (resultCategory += `${item}/`));
              resultCategory = resultCategory.slice(0, -1);
              $('#search-condition-category').show();
              $('#search-condition-category .card-text').text(resultCategory);
            } else {
              $('#search-condition-category').hide();
            }
            // ハッシュタグ
            if (pHashtag.length > 0) {
              let resultHashtag: string = '';
              pHashtag.forEach((item) => (resultHashtag += `${item}/`));
              resultHashtag = resultHashtag.slice(0, -1);
              $('#search-condition-hashtag').show();
              $('#search-condition-hashtag .card-text').text(resultHashtag);
            } else {
              $('#search-condition-hashtag').hide();
            }
            // アイウエオ・ABC
            const resultAbc = nameIndexs.find((item) => item === pNameIndex);
            if (resultAbc !== undefined) {
              $('#search-condition-abc').show();
              $('#search-condition-abc .card-text').text(resultAbc);
            } else {
              $('#search-condition-abc').hide();
            }
            // 都道府県
            const resultPrefecture = prefectures.find(
              (item) => item.province_code === pPrefecture
            )?.province_name;
            if (resultPrefecture !== undefined) {
              $('#search-condition-prefecture').show();
              $('#search-condition-prefecture .card-text').text(
                resultPrefecture
              );
            } else {
              $('#search-condition-prefecture').hide();
            }

            // 再検索
            const research = () => {
              const show = $('#show-list').val() as string;
              const fair = $('#fair-list').val() as string;
              const freeword = $('#freeword-input').val() as string;
              let category = $('#category-list').val() as string;
              let hashtag = '';
              let abc = $('#abc-list').val() as string;
              $('#hashtag-list .hashtag-label.active').each((i, el) => {
                if (i !== 0) hashtag += ',';
                hashtag += encodeURIComponent(`${$(el).data('value')}`);
              });
              const prefecture = $('#prefecture-list').val() as string;
              const order = $('#result-sort option:selected').val() as string;

              const _newParams = {
                show,
                content: '',
                floor: '',
                fair,
                freeword: encodeURIComponent(freeword),
                category,
                hashtag,
                abc,
                prefecture,
                order,
              };

              if (
                show == '' &&
                fair == '' &&
                freeword == '' &&
                category == '0' &&
                hashtag == '' &&
                prefecture == '0' &&
                abc == ''
              ) {
                Alert({
                  icon: 'warning',
                  trnKey: 'errSearchCondition',
                });
              } else {
                const urlParam = createParams(_newParams);
                window.location.href = `./${urlParam}`;
              }
            };

            // 並べ替え順の反映
            $('#result-sort').val(pOrder);

            // 検索結果の並べ替え
            $('#result-sort').on('change', research);

            // 「絞り込み」ボタン クリック時
            $('#search').on('click', research);

            // もっと表示する
            $('#search-condition-more-btn').on('click', () => {
              const show = $('#search-condition-more').hasClass('show');
              if (show) {
                $('#search-condition-more-btn-expand').show();
                $('#search-condition-more-btn-expand-icon').show();
                $('#search-condition-more-btn-shrink').hide();
                $('#search-condition-more-btn-shrink-icon').hide();
              } else {
                $('#search-condition-more-btn-expand').hide();
                $('#search-condition-more-btn-expand-icon').hide();
                $('#search-condition-more-btn-shrink').show();
                $('#search-condition-more-btn-shrink-icon').show();
              }
            });

            // さらに絞り込み
            // ショー選択
            let showList: string =
              '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';
            shows.forEach((item) => {
              showList += `<option value="${item.show_code}">${item.show_name}</option>`;
            });
            $('#show-list').html(showList);
            $('#show-list').val(pShow);

            // オンライン出展の時、フロア選択を選択不可に
            if (pShow === '91online') {
              $('#floor-list').prop('disabled', true);
            } else {
              $('#floor-list').prop('disabled', false);
            }

            // ショー変更時 フロア・フェアを再取得
            $('#show-list').on('change', () => {
              // フロア・フェア 初期化
              $('#floor-list').val('');
              $('#fair-list').val('');
              let floorList: string =
                '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';
              let fairList: string =
                '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';

              const _pShow = $('#show-list').val() as string;

              // オンライン出展の時、フロア選択を選択不可に
              if (_pShow === '91online') {
                $('#floor-list').prop('disabled', true);
              } else {
                $('#floor-list').prop('disabled', false);
              }

              const _floorJqXHR = getFloorJqXHR(_pShow);
              const _fairJqXHR = getFairJqXHR(_pShow);
              $.when(_floorJqXHR, _fairJqXHR)
                .done((_jqFloors, _jqFair) => {
                  const _floors: Floor[] = _jqFloors[0];
                  const _fairs: Fair[] = _jqFair[0];

                  // フロア選択
                  _floors.forEach((item) => {
                    floorList += `<option value="${item.floor_code}">${item.floor_name}</option>`;
                  });
                  $('#floor-list').html(floorList);

                  // フェア名
                  _fairs.forEach((item) => {
                    fairList += `<option value="${item.fair_code}">${item.fair_name}</option>`;
                  });
                  $('#fair-list').html(fairList);
                })
                .catch(() => {
                  $('#floor-list').html(floorList);
                  $('#fair-list').html(fairList);
                })
                .always(() => {
                  translate(); // 翻訳
                });
            });

            // 特集選択
            let contentList: string =
              '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';
            contents.forEach((item) => {
              contentList += `<option value="${item.sc_key}">${item.content_name}</option>`;
            });
            $('#content-list').html(contentList);
            $('#content-list').val(pContent);

            // フロア選択
            let floorList: string =
              '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';
            floors.forEach((item) => {
              floorList += `<option value="${item.floor_code}">${item.floor_name}</option>`;
            });
            $('#floor-list').html(floorList);
            $('#floor-list').val(pFloor);

            // フェア名
            let fairList: string =
              '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';
            fairs.forEach((item) => {
              fairList += `<option value="${item.fair_code}">${item.fair_name}</option>`;
            });
            $('#fair-list').html(fairList);
            $('#fair-list').val(pFair);

            // フリーワード検索
            $('#freeword-input').val(pFreeword ?? '');

            // グッズ選択 category
            let categoryList: string =
              '<option class="trn" data-trn-key="all" value="0" selected>すべて</option>';
            categories.forEach((item) => {
              const text = item.category_name;
              const value = item.category_code;
              categoryList += `<option value="${value}">${text}</option>`;
            });
            $('#category-list').html(categoryList);
            // 条件がひとつの場合
            $('#category-list').val(
              pCategory.length !== 0 ? pCategory[0] : '0'
            );

            // ハッシュタグ
            let hashtagList: string = '';
            hashtags.forEach((item) => {
              const active: boolean = pHashtag.indexOf(item) !== -1;
              hashtagList += LabelComponent({
                className: 'hashtag-label',
                value: item,
                name: `#${item}`,
                active: active,
              });
            });
            $('#hashtag-list').html(hashtagList);
            $(document).on('click', '.hashtag-label', function () {
              const active: boolean = $(this).hasClass('active');
              if (active) {
                $(this).removeClass('active');
              } else {
                $(this).addClass('active');
              }
            });

            // アイウエオ・ABC
            let abcList: string =
              '<option class="trn" data-trn-key="all" value="" selected>すべて</option>';
            nameIndexs.forEach((item) => {
              abcList += `<option value="${item}">${item}</option>`;
            });
            $('#abc-list').html(abcList);
            $('#abc-list').val(pNameIndex);

            // 都道府県
            let prefectureList: string =
              '<option class="trn" data-trn-key="all" value="0" selected>すべて</option>';
            prefectures.forEach((item) => {
              prefectureList += `<option value="${item.province_code}">${item.province_name}</option>`;
            });
            $('#prefecture-list').html(prefectureList);
            $('#prefecture-list').val(pPrefecture);
          }
        )
        .fail(() => {
          Alert({
            icon: 'error',
            trnKey: 'errGetData',
            confirmButtonKey: 'errReload',
            onClick: () => location.reload(),
          });
        })
        .always(() => {
          translate(); // 翻訳
          $('#loading').hide(); // ロードを解除
        });
    });
});
